import * as React from 'react';
import ResponsiveImage from '../ResponsiveImage';

import type { JSX } from "react";

export interface IImage {
  alt: string;
  url: string;
  dimensions: {
    width: number;
    height: number;
  };
}

interface IContainer {
  backgroundColor?: string;
  hasPadding?: boolean;
  smallBox?: boolean;
}

interface IImageContainer {
  hasImageOnMobile?: boolean;
  withOriginalImgSize?: boolean;
}

interface IInformativeBox extends IContainer, IImageContainer {
  children: React.ReactNode;
  img?: IImage;
  icon?: JSX.Element;
  UNSAFE_className?: string;
}

const InformativeBox: React.FC<IInformativeBox> = ({
  img,
  icon,
  children,
  backgroundColor = 'var(--clr-primary-2)',
  hasPadding = true,
  hasImageOnMobile = false,
  smallBox = false,
  withOriginalImgSize = false,
  UNSAFE_className,
}) => (
  <>
    <div
      className={`
          tw-flex tw-items-center tw-gap-x-3
          ${hasPadding ? (smallBox ? 'tw-p-4 tw-px-6' : 'tw-p-6') : ''}
          ${smallBox ? 'tw-rounded-lg' : 'tw-rounded-2xl'}
          ${UNSAFE_className || ''}
        `}
      style={{ backgroundColor }}
    >
      {(icon || img) && (
        <div
          className={`
          ${withOriginalImgSize ? 'tw-min-w-0' : 'tw-min-w-[64px]'}]
          ${hasImageOnMobile ? '' : 'tw-hidden desktop:tw-block'}
          tw-flex tw-items-center tw-justify-center
        `}
        >
          {icon
            ? icon
            : img && (
                <ResponsiveImage
                  src={img?.url || ''}
                  alt={img?.alt}
                  width={img && withOriginalImgSize ? img.dimensions.width : 64}
                  height={
                    img && withOriginalImgSize ? img.dimensions.height : 64
                  }
                />
              )}
        </div>
      )}
      {children}
    </div>
  </>
);

export default InformativeBox;
